<template>
  <div class="attend-course-record">
    <vx-list class="list-wrap" enable :api="api" :params="params" @load="onLoad">
      <div class="title">仅记录日志功能上线(2022年12月6日)后的操作</div>
      <div class="cwlist">
        <div class="cw" v-for="item in list" :key="item.id">
          <div class="ln ln1 van-hairline--bottom">
            <div class="l">{{ item.typeText }}</div>
            <div class="r">{{ item.createTime | formatDatetime('yyyy-MM-dd hh:mm') }}</div>
          </div>
          <div class="ln">
            <div class="l">操作人</div>
            <div class="r">{{ item.operatorName }}</div>
          </div>
          <div class="ln">
            <div class="l">操作内容</div>
            <div class="r">{{ item.resultContentText }}</div>
          </div>
          <div class="inner" v-if="item.type == 2 || item.type == 3 || item.type == 4">
            <div class="ln" >
              <div class="l">修改前</div>
              <div class="r" >
                {{ item.beforeContentText || '-'}}
              </div>
            </div>
            <div class="ln">
              <div class="l">修改后</div>
              <div class="r" >
                {{ item.afterContentText || '-'}}
              </div>
            </div>          
          </div>
          <div class="btn" v-if="item.type == 1" @click="gotoDetail(item)">
            查看变更详情 <van-icon name="arrow"></van-icon>
          </div>
        </div>
      </div>
      <van-empty
        v-if="!loading && !list.length"
        image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
        description="暂无操作日志～"
        image-size="128"
        style="padding-top: 50px"
      ></van-empty>
    </vx-list>
  </div>
</template>

<script>
export default {
  name: 'attend-course-record',
  components: {},

  data() {
    return {
      pageTitle: '点名操作日志',
      api: this.$api.arrangeLogPage,
      courseArrangeId: +this.$route.params.id,
      params: {
        courseArrangeId: +this.$route.params.id,
      },
      list: [],
      loading: false,
    };
  },
  computed: {},
  methods: {
    onLoad(list, res) {
      this.list = list;
      this.loading = false;
    },
    gotoDetail(item) {
      this.$router.push({
        name: 'attend-course-record-detail',
        params: {
          id: this.courseArrangeId,
          logId: item.id,
          operatorName: item.operatorName,
          createTime: item.createTime,
        }
      });
    }
  },
  created() {
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.attend-course-record {
  .list-wrap {
    height: 100%;
    .title {
      padding: calc(var(--gap) * 8) calc(var(--gap) * 16) 0;
      color: var(--g6);
    } 
    .cwlist {
      padding: calc(var(--gap) * 4) calc(var(--gap) * 16);

      .cw {
        margin-top: calc(var(--gap) * 12);
        margin-bottom: calc(var(--gap) * 12);
        padding-left: calc(var(--gap) * 16);
        padding-right: calc(var(--gap) * 16);
        padding-bottom: calc(var(--gap) * 8);
        border-radius: var(--radius-sm);
        background: var(--white);
        overflow: hidden;
        .inner {
          margin: calc(var(--gap) * 8) 0 calc(var(--gap) * 12);
          background-color: var(--g1);
          border-radius: var(--radius-sm);
          padding: 8px 12px;
        }
        .btn {
          width: 100%;
          display:flex;
          align-items: center;
          text-align: right;
          color:var(--c1);
          font-size:var(--fs-sm);
          line-height:var(--lh-sm);
          justify-content: flex-end;
        }
        .ln {
          display: flex;
          justify-content: space-between;
          padding-top: calc(var(--gap) * 6);
          padding-bottom: calc(var(--gap) * 6);
          .l {
            color: var(--g6);
          }
          .r {
            flex: 1;
            padding-left: calc(var(--gap) * 16);
            color: var(--g7);
            text-align: right;
          }
          &.ln1 {
            padding-top: calc(var(--gap) * 16);
            padding-bottom: calc(var(--gap) * 12);
            .l {
              color: var(--g8);
              font-weight: var(--bold);
            }
            .r {
              color: var(--g6);
            }
          }
        }
      }
    }
  }
}
</style>